import { render } from "./Article.vue?vue&type=template&id=98859f2c&scoped=true"
import script from "./Article.vue?vue&type=script&lang=js"
export * from "./Article.vue?vue&type=script&lang=js"

import "./Article.vue?vue&type=style&index=0&id=98859f2c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-98859f2c"]])

export default __exports__